<!-- Floating hamburger button -->
<button class="floating-menu-toggle" (click)="toggleMobileMenu()" [class.active]="isMobileMenuOpen" type="button"
  aria-label="Toggle menu">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
</button>

<!-- Mobile overlay -->
<div class="mobile-overlay" (click)="closeMobileMenu()" [class.active]="isMobileMenuOpen"
  [style.display]="isMobileMenuOpen ? 'block' : 'none'">
</div>

<!-- Desktop toggle button -->
<button class="desktop-toggle-btn" (click)="toggleDesktopSidebar()" [class.collapsed]="isDesktopSidebarCollapsed"
  type="button" aria-label="Toggle sidebar">
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
</button>

<!-- Navigation sidebar -->
<nav class="staff-nav" [class.mobile-open]="isMobileMenuOpen" [class.desktop-collapsed]="isDesktopSidebarCollapsed">
  <div class="nav-header">
    <h2 class="nav-title">เมนูหลัก</h2>
    <button class="mobile-close" (click)="closeMobileMenu()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <div class="nav-content">
    <!-- Navigation sections -->
    <div class="nav-section">
      <h3 class="section-title">Admin</h3>
      <ul class="nav-list">
        <!-- <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('dashboard')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
            <span>รายงานผู้บริหาร</span>
          </button>
        </li> -->
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('users')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>จัดการผู้ใช้งาน</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('reference-user-data')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10,9 9,9 8,9"></polyline>
            </svg>
            <span>ข้อมูลอ้างอิงผู้ใช้งาน</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('roles')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12l2 2 4-4"></path>
              <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
              <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
              <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"></path>
              <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"></path>
            </svg>
            <span>จัดการหน้าที่</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('organizations')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 21h18"></path>
              <path d="M5 21V7l8-4v18"></path>
              <path d="M19 21V11l-6-4"></path>
              <path d="M9 9v.01"></path>
              <path d="M9 12v.01"></path>
              <path d="M9 15v.01"></path>
              <path d="M9 18v.01"></path>
            </svg>
            <span>จัดการหน่วยงาน</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('staff')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 11c0 0-1-1-3-1s-3 1-3 1"></path>
              <path d="M16 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M18 9a3 3 0 0 0 0-6"></path>
            </svg>
            <span>จัดการเจ้าหน้าที่</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('courses')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
            <span>การจัดการคอร์สสัมมนา (Admin)</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('exams')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
              <rect x="9" y="3" width="6" height="4" rx="1"></rect>
              <path d="M9 12h6"></path>
              <path d="M9 16h6"></path>
            </svg>
            <span>การจัดการสอบ</span>
          </button>
        </li>
        <!-- <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('reports')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10,9 9,9 8,9"></polyline>
            </svg>
            <span>รายงาน</span>
          </button>
        </li> -->
      </ul>

      <hr>

      <h3 class="section-title">ใบคำขอ</h3>
      <ul class="nav-list">
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('request-regis-new-user')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>ใบคำขอทำบัตรสมาชิกใหม่</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('request-renew-member')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>ใบคำขอต่ออายุบัตรสมาชิก</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('request-regis-appraiser')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>ใบคำขอขึ้นทะเบียนผู้ประเมินหลัก</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('request-renew-appraiser')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>ใบคำขอต่ออายุบัตรผู้ประเมิน</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('cpd-hours')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>ใบคำขอสมัครคอร์สอบรม/สัมมนา</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('exam-lists')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
              <rect x="9" y="3" width="6" height="4" rx="1"></rect>
              <path d="M9 12h6"></path>
              <path d="M9 16h6"></path>
            </svg>
            <span>ใบคำขอสมัครสอบ</span>
          </button>
        </li>
      </ul>

      <hr>

      <h3 class="section-title">การเงิน</h3>
      <ul class="nav-list">
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('payment-verification')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <path d="M9 12l2 2 4-4"></path>
            </svg>
            <span>ตรวจสอบการชำระเงิน</span>
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('account-worklist')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
            <span>การจัดการทางบัญชี</span>
          </button>
        </li>
      </ul>
    </div>

    <!-- <div class="nav-section">
      <h3 class="section-title">ระบบ</h3>
      <ul class="nav-list">
        <li class="nav-item">
          <button class="nav-link" (click)="onNavigate('settings')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
            <span>การตั้งค่า</span>
          </button>
        </li>
      </ul>
    </div> -->
  </div>
</nav>